import type { MouseEvent } from "react";
import type { OpportunityCardSummaryFieldsFragment } from "src/graphql";

/**
 * True for clicks that should keep native link behavior (open in new
 * tab/window, download) instead of being intercepted by the app.
 */
export function isModifiedClick(event: MouseEvent): boolean {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
}

type OpportunityCardPage = {
  amp_opportunities: OpportunityCardSummaryFieldsFragment[];
};

export function flattenOpportunityPages(
  pages: OpportunityCardPage[],
): OpportunityCardSummaryFieldsFragment[] {
  const cards = new Map<string, OpportunityCardSummaryFieldsFragment>();
  for (const page of pages) {
    for (const card of page.amp_opportunities) {
      if (!cards.has(card.id)) {
        cards.set(card.id, card);
      }
    }
  }
  return [...cards.values()];
}
